import TemplateMenu from './TemplateMenu'

export default TemplateMenu